import Vue from 'vue';
import injector from 'vue-inject';
import store from '../store';

const api = injector.get('api');

class Invoice {
    fetchPackageList() {
        Vue.http.get(api.package.boughtList()).then(response => {
            store.commit('setPackagesList', response.body.results);
        });
    }
    generateInvoice(packageId) {
        let _packages = JSON.parse(JSON.stringify( store.getters.packages ));
        _packages.find((element) => {
            return element.id === packageId
        });
        Vue.http.get(api.invoice.generate(packageId))
            .then(() => {
                this.fetchPackageList();
                store.commit('removePackageFromQueue', packageId);
            });
    }
    getDownloadLink(invoiceId) {
        return API + api.invoice.download(invoiceId);
    }
}

injector.service('invoice', Invoice);



// WEBPACK FOOTER //
// ./src/services/invoices.js